import { Controller } from '@hotwired/stimulus'
import { Modal } from 'bootstrap'

import 'semantic-ui-dropdown/dropdown.min'
import 'semantic-ui-dropdown/dropdown.min.css'
import 'semantic-ui-transition/transition.min.js'
import 'semantic-ui-transition/transition.min.css'
import 'semantic-ui-api/api.js'
import 'semantic-ui-search/search.min.js'
import 'semantic-ui-form/form.min.js'
import { useEmptyMessageVisibilitySync } from '../../mixins/useEmptyMessageVisibilitySync.js'

export default class extends Controller {
  static targets = ['listRepresentation', 'formField', 'linkedDocumentRowTemplate', 'emptyMessage']

  connect () {
    useEmptyMessageVisibilitySync(this)
    this.sync(this.listRepresentationTarget, this.emptyMessageTarget)
  }

  addItems (event) {
    const linkedDocuments = event.detail.documents

    const inputFieldValues = $(this.formFieldTarget).val() === '' ? '[]' : $(this.formFieldTarget).val()
    const inputFieldParsedValues = JSON.parse(inputFieldValues)

    linkedDocuments.forEach((item) => {
      if (!inputFieldParsedValues.includes(item.id)) {
        const linkedDocumentRow = document.importNode(this.linkedDocumentRowTemplateTarget.content, true)

        $(linkedDocumentRow).find('.name').text(item.name)
        $(linkedDocumentRow).find('.id').text(item.id)
        $(linkedDocumentRow).find('.url').attr('href', `/documents/edit/${item.id}`)

        $(this.listRepresentationTarget).append(linkedDocumentRow)

        inputFieldParsedValues.push(item.id)
      }
    })

    $(this.formFieldTarget).val(JSON.stringify(inputFieldParsedValues))

    this.sync(this.listRepresentationTarget, this.emptyMessageTarget)
  }

  removeItem (event) {
    const documentId = $(event.target.closest('.link')).find('.id').text()
    const inputFieldValues = $(this.formFieldTarget).val()

    const linkElement = event.target.closest('.link')
    const inputFieldParsedValues = JSON.parse(inputFieldValues)

    inputFieldParsedValues.splice(inputFieldParsedValues.indexOf(documentId), 1)

    $(this.formFieldTarget).val(JSON.stringify(inputFieldParsedValues))

    linkElement.remove()

    event.preventDefault()
    event.stopPropagation()

    this.sync(this.listRepresentationTarget, this.emptyMessageTarget)
  }
}
